/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Open Source Version is distributed with Sencha Ext JS pursuant to a FLOSS Exception agreed upon
 * between Sonatype, Inc. and Sencha Inc. Sencha Ext JS is licensed under GPL v3 and cannot be redistributed as part of a
 * closed source work.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

import {assign, createMachine} from 'xstate';

/**
 * @deprecated Classic UI only; unreachable from the Preview UI. Left on XState v4 semantics
 * pending Classic UI deletion (NEXUS-55299) ahead of the XState v5 upgrade (NEXUS-51654).
 */
export default createMachine(
    {
      initial: 'idle',
      context: {
        userToken: null,
      },
      states: {
        idle: {
          on: {
            ACCESS: 'accessToken',
            RESET: 'resetToken',
          }
        },
        accessToken: {
          invoke: {
            id: 'accessToken',
            src: 'accessToken',
            onDone: {
              target: 'showToken',
              actions: 'setToken'
            },
            onError: {
              target: 'idle',
              actions: 'showAccessError'
            }
          },
        },
        resetToken: {
          invoke: {
            id: 'resetToken',
            src: 'resetToken',
            onDone: {
              target: 'idle',
              actions: 'showResetSuccess'
            },
            onError: {
              target: 'idle',
              actions: 'showResetError'
            }
          }
        },
        showToken: {
          after: {
            60000: 'idle'
          },
          exit: 'unsetToken',
          on: {
            ACCESS: 'accessToken',
            RESET: 'resetToken',
            HIDE: {
              target: 'idle',
              actions: 'unsetToken'
            }
          }
        }
      },
      on: {
        RETRY: {
          target: 'idle'
        }
      }
    },
    {
      actions: {
        showResetSuccess: () => {
          console.error('showResetSuccess function must be overridden in order to show the appropriate message');
        },
        showResetError: () => {
          console.error('showResetError function must be overridden in order to show the appropriate message');
        },
        showAccessError: () => {
          console.error('showAccessError function must be overridden in order to show the appropriate message');
        },
        setToken: assign({
          token: (_, event) => event.data.data
        }),
        unsetToken: assign({
          token: null
        })
      }
    }
);
